import type { WasteDepot } from '../../types';
import { PointEntityDetailsPanel } from '../../../../spatial/components/PointEntityDetailsPanel';

export interface DepotDetailsPanelProps {
  depot: WasteDepot;
  onClose: () => void;
}

function formatAcceptedWasteTypes(value: WasteDepot['metadata']): string {
  if (!value?.acceptedWasteTypes?.length) {
    return 'Sin definir';
  }

  return value.acceptedWasteTypes.join(', ');
}

export function DepotDetailsPanel({
  depot,
  onClose,
}: DepotDetailsPanelProps): JSX.Element {
  return (
    <PointEntityDetailsPanel
      title="Depósito"
      code={depot.code}
      subtitle={depot.name}
      projectId={depot.project.id}
      entityType="waste_depot"
      entityId={depot.id}
      coordinates={depot.geometry.coordinates as [number, number]}
      onClose={onClose}
      fields={[
        { label: 'Tipo', value: depot.depotType },
        { label: 'Estado', value: depot.status },
        { label: 'Capacidad', value: depot.capacity ? `${depot.capacity.toLocaleString()} m³` : 'Sin definir' },
        { label: 'Dirección', value: depot.metadata?.address || 'Sin definir' },
        { label: 'Horario', value: depot.metadata?.operatingHours || 'Sin definir' },
        { label: 'Contacto', value: depot.metadata?.contactPhone || 'Sin definir' },
        { label: 'Residuos aceptados', value: formatAcceptedWasteTypes(depot.metadata) },
        { label: 'Ubicación', value: `${depot.geometry.coordinates[0].toFixed(6)}, ${depot.geometry.coordinates[1].toFixed(6)}` },
      ]}
    />
  );
}
